export const irUrl = (url) => {
    window.open(url )
}